import {ChangeDetectionStrategy, Component, inject, OnDestroy} from '@angular/core';

import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {BarcodeFormat} from '@zxing/library';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {MatButton} from '@angular/material/button';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {isDefined} from '@aviary/store/common/typing.helpers';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'mx-mobile-barcode-scanner',
  templateUrl: './mobile-barcode-scanner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ZXingScannerModule, InputFormFieldComponent, MatButton, MatIcon]
})

export class MobileBarcodeScannerComponent implements OnDestroy {
  public readonly scannerForm: ExtendedFormGroup = inject(ExtendedFormBuilder).nonNullable.extendedGroup({barcode: ['']});
  public barcodeControl: ExtendedFormControl = getExtendedControlFrom(this.scannerForm, 'barcode');

  // Books are standardized to EAN_13.  These should cover most items the library might have, but we can easily add more here if this is too restrictive.
  public readonly acceptedFormats = [BarcodeFormat.EAN_13, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E, BarcodeFormat.CODE_128];
  public scannerEnabled: boolean = false;
  public cameras: MediaDeviceInfo[] = [];
  public currentCamera?: MediaDeviceInfo;

  public activateMobileScanner() {
    this.scannerEnabled = true;
  }

  public onBarcodeScanned(value: string) {
    // Patch the value to the input, then close the scanner.
    this.barcodeControl.patchValueAndMarkAsDirty(value);
    this.closeScanner();
  }

  public onCameraChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.currentCamera = this.cameras.find(cam => cam.deviceId === target.value);
  }

  public onCamerasDetected(devices: MediaDeviceInfo[]) {
    if (devices.length > 0) {
      this.cameras = devices;
      this.currentCamera = devices[0];
    }
  }

  public get isCameraSelected(): boolean {
    return isDefined(this.currentCamera);
  }

  closeScanner() {
    this.scannerEnabled = false;
    this.currentCamera = undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- "error" won't be unused anymore once it's used!
  onError(error: Error) {
    // TODO: Eventually, this should show the error in the snack bar.  But for now, those don't exist in Aviary.
  }

  ngOnDestroy() {
    this.closeScanner();
  }
}
